goog.provide('el8.app.settings.staffGroupDelegates');

goog.require('el8.app.settings.reactTab')

el8.app.settings.staffGroupDelegates = el8.app.settings.reactTab({
    containerId: 'staff-group-delegates-settings',
    renderFnName: 'renderStaffGroupDelegatesSettings',
});
